import { render, staticRenderFns } from "./IcoDsdContent.vue?vue&type=template&id=3f021a2a"
import script from "./IcoDsdContent.vue?vue&type=script&lang=js"
export * from "./IcoDsdContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports